import Vue from 'vue';

export const dialogsEvents = new Vue();

export const DIALOG_TYPES = {
	CONFIRM: 'CONFIRM',
	ALERT: 'ALERT',
	LOADER: 'LOADER',
	WELCOME: 'WELCOME',
	BUSINESS_ONLY: 'BUSINESS_ONLY',
	SUBSCRIPTION_EXPIRED: 'SUBSCRIPTION_EXPIRED',
};

export class DialogOptions {
	constructor(options) {
		this.title = options['title'] || '';
		this.titleClass = options['titleClass'] || 'title grey lighten-4';
		this.content = options['content'] || '';
		this.confirmText = options['confirmText'] || 'Confirm';
		this.cancelText = options['cancelText'] || 'Cancel';

		this.fullscreen = options['fullscreen'] || false;
		this.hideOverlay = options['hide-overlay'] || false;
		this.noClickAnimation = options['no-click-animation'] || false;
		this.persistent = options['persistent'] || false;
		this.retainFocus = options['retain-focus'] || true;
		this.scrollable = options['scrollable'] || false;
		this.light = options['light'] || false;
		this.dark = options['dark'] || false;

		this.maxWidth = options['max-width'] || 'none';
		this.width = options['width'] || '500px';
		this.origin = options['origin'] || 'center center';
		this.transition = options['transition'] || 'dialog-transition';

		this.value = options['value'] || undefined;

		this.onCancel = options['onCancel'] ? options['onCancel'] : () => {};
		this.onConfirm = options['onConfirm'] ? options['onConfirm'] : () => {};
		this.type = options['type'] || DIALOG_TYPES.ALERT;
		this.loaderPromise =
			options['loaderPromise'] ||
			new Promise(
				(resolve) => {
					setTimeout(() => {
						resolve(null);
					}, 4000);
				},
				(reject) => {
					setTimeout(() => {
						reject(null);
					}, 4000);
				},
			);
	}
}

export default (params) => {
	if (!(params instanceof DialogOptions)) return;

	dialogsEvents.$emit('add-dialog', params);
};
